import React from "react";
import { createComponent, EventName } from "@lit/react";
import { BeamNonprofitSelectEvent } from "../../utils/events";
import { BeamSelectNonprofit as _BeamSelectNonprofit } from "./index";

export const BeamSelectNonprofit = createComponent({
  tagName: "beam-select-nonprofit",
  elementClass: _BeamSelectNonprofit,
  react: React,
  events: {
    onNonprofitSelect: BeamNonprofitSelectEvent.eventName as EventName<BeamNonprofitSelectEvent>,
  },
});

export default BeamSelectNonprofit; // default alias for use with async import utils like next/dynamic and react.lazy
